import React, { Component } from 'react'
import TagMeasurements from '../components/TagMeasurements'
import { fetchMeasurementsByTag } from '../api'

class TagContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      measurements: []
    }
  }
  componentDidMount() {
    this.fetchMeasurementsByTag(this.props.match.params.tag)
  }

  fetchMeasurementsByTag = tag => {
    this.setState({ loading: true, search: false, measurements: [] })
    fetchMeasurementsByTag(tag).then(res => {
        this.setState({ measurements: res.data, loading: false })
      })
  }

  render() {
    return (
      <TagMeasurements
        tag={this.props.match.params.tag}
        data={this.state.measurements}
      />
    )
  }
}

export default TagContainer;
